import lottieWeb from 'lottie-web';
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
export default {
  data() {
    return {
      aiBot: null,
      aiJson: require('@/assets/json/AIRobot.json'),
      textByStatus: {
        0: 'defaultText',
        // 默认显示信息
        1: 'voiceSend',
        // 正在识别语音,发送命令
        2: 'sendSuccess',
        // 命令发送成功
        3: 'sendFailed',
        // 命令发送失败
        4: 'programNotExists' // 请选择一个正在工作的
      }
    };
  },

  computed: {
    ...mapState({
      State: state => state
    })
  },
  mounted() {
    this.initAiBot();
  },
  methods: {
    initAiBot() {
      const animation = lottieWeb.loadAnimation({
        container: document.getElementById('aiBotBox'),
        animationData: this.aiJson,
        loop: true,
        autoplay: true
      });
      animation.play();
    },
    showParticipantSetting() {
      Bus.$emit('showParticipantSetting');
    }
  }
};